// Centered loading indicator. A gradient ring spinner (brand colours) with an
// optional label. `screen` fills the full viewport (used for the boot auth
// check); the default fills the content area it's placed in.
export function Loader({ label = "Loading…", screen = false }: { label?: string; screen?: boolean }) {
  return (
    <div className={screen ? "loader-wrap screen" : "loader-wrap"} role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="loader-label">{label}</span>
    </div>
  );
}
